export default __webpack_public_path__ + "static/media/notfoundimage.ef55a1d0.svg";